import uuidv4 from "uuid/v4";
import Vue from "vue";
import router from "../../router";
import {
	getLoggedUserCookie,
	logoutUserCookie,
	storeUserCookie,
} from "../../tools/auth";
import {
	ERequestType,
	fetchGetHelper,
	fetchPostHelper,
} from "../../tools/fetch";

/*************************************
 State
 **/
const state = {
	currentUser: null, // -> currentUser object
	currentUserPublic: null, // -> currentUser object
	aUsers: {},
};

/*************************************
 Getters
 **/
const getters = {
	getUser: (state) => {
		return state.currentUser;
	},
	getUserType: (state) => {
		if (
			state.currentUser !== null &&
			state.currentUser !== undefined &&
			state.currentUser.type !== undefined
		)
			return state.currentUser.type;
		return "classique";
	},
	getAUsers: (state) => {
		return state.aUsers;
	},
	getUidPublic: (state) => {
		return state.currentUserPublic;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	setUser(state, dbRefUser) {
		state.currentUser = dbRefUser;
	},
	setUserDatas(state, datas) {
		Vue.set(state.currentUser, "user", datas);
	},
	setAUser(state, dbRefUser) {
		state.aUsers = dbRefUser;
	},
	setUidPublic(state, dbRefUser) {
		state.currentUserPublic = dbRefUser;
	},
	resetStore(state) {
		state.currentUser = null; // -> currentUser object
		state.currentUserPublic = null; // -> currentUser object
	},
};

/*************************************
 Action
 **/
const actions = {
	cleanStore: function ({ state, rootState, commit, dispatch }) {
		commit("resetStore");
	},
	/**
	 * Login function return Promise
	 * @param {*} storeParams
	 */
	logout: function ({ state, getters, rootState, commit, dispatch }) {
		return new Promise((resolve, reject) => {
			// remove user stored in this store
			let userDatas = getters["getUser"];
			dispatch(
				"serviceWorker/removeCurrentSubscription",
				userDatas.user.restoid,
				{ root: true },
			).then((el) => {
				logoutUserCookie();
				commit("resetStore");
				commit("setUser", null);
				// return to login page
				router.push({ name: "Login" });
				window.location.reload();
			});
		});
	},
	/**
	 * Login function return Promise
	 * @param {*} storeParams
	 * @param {*} payload
	 */
	login: function ({ state, rootState, commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			getLoggedUserCookie()
				.then((res) => {
					commit("setUser", res);
					resolve(res);
				})
				.catch(() => {
					if (payload) {
						fetchPostHelper(ERequestType.USERS.LOGIN, {
							email: payload.email,
							password: payload.password,
						})
							.then((res) => {
								storeUserCookie(res.data);
								dispatch("storeUser").then((u) => {
									if (u.role === "Permanence")
										router.push({ name: "Permanence" });
									else router.replace("restaurant");
									resolve();
								});
							})
							.catch((err) => {
								console.error("Connect user Error", err);
								reject(new Error(`Connection error to MongoDb${err}`));
								router.push({ name: "Login" });
							});
					} else {
						console.error("Please provide an email and a password");
						router.replace("login");
					}
				});
		});
	},
	setNewPWD: function ({ state, rootState, commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			fetchPostHelper(ERequestType.USERS.CHANGE_PWD, {
				email: payload.email,
				newPassword: payload.newPassword,
				newEmail: payload.newEmail,
			})
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
					reject(new Error(`error to change mdp${err}`));
				});
		});
	},
	async signUp({ state, getters, rootState, commit, dispatch }, payload) {
		return new Promise(async (resolve, reject) => {
			let userDatas = getters["getUser"];
			let restoid = uuidv4();
			await fetchPostHelper(
				ERequestType.USERS.REGISTER,
				{
					email: payload.email,
					password: payload.password,
					restoid: restoid,
					name: payload.name,
					secondname: payload.secondname,
				},
				userDatas.token,
			)
				.then(async (result) => {
					await fetchPostHelper(
						ERequestType.USERSINFOS,
						{
							adresse: payload.adresse,
							codera: payload.codera,
							cp: payload.cp,
							denomination: payload.denomination,
							restoid: restoid,
							formejuridique: payload.formejuridique,
							lang: "fr",
							restoName: payload.restoName,
							siret: payload.siret,
							tva: payload.tva,
							type: payload.type,
							ville: payload.ville,
							emailRestoSend: payload.email,
							emailRestoReply: payload.email,
							web: payload.web,
						},
						userDatas.token,
					);
					resolve("User was created");
				})
				.catch((err) => {
					this.alert = true;
					this.alertMessage = err.data.message;
					console.error("Register new user error", err);
					reject(err);
				});
		});
	},
	saveNewUser: function ({ state, rootState, commit, dispatch }, payload) {},
	/**
	 * get uid in url parameters
	 * @param {*} param0
	 */
	storePublicUser: function ({ state, rootState, commit, dispatch }) {
		if (
			router.currentRoute.params.eventid !== undefined &&
			router.currentRoute.params.id !== undefined
		) {
			commit("setUidPublic", router.currentRoute.params.id);
			dispatch("loadPublicStoreModules", router.currentRoute.params.eventid, {
				root: true,
			});
		} else if (router.currentRoute.params.id !== undefined) {
			commit("setUidPublic", router.currentRoute.params.id);
			dispatch("loadPublicStoreModules", null, { root: true });
		}
	},
	async storeUser({ state, rootState, commit, dispatch }) {
		return new Promise(async (resolve, reject) => {
			// test if connected to mongodb
			await getLoggedUserCookie()
				// cookie connection to mongodb exist
				.then(async (res) => {
					let user = res.user;
					commit("setUser", res);
					let uid = user.restoid;
					dispatch("checkUserStillValid");
					if (router.currentRoute.name === "PRedirect") {
						// check role of current user logged before load all
						if (user.role === "User") {
							router.replace({ name: "Restaurant" });
						} else {
							uid = router.currentRoute.params.id;
						}
						await dispatch("resetAllStore", null, { root: true }).then(
							async () => {
								// window.localStorage.clear()
								await dispatch("storeAndLoadData", uid).then((u) => {
									resolve(u);
								});
							},
						);
					} else if (router.currentRoute.name === "Permanence") {
						// dispatch('langues/loadLangues', null, {root: true})
						await dispatch("storeAndLoadData", uid).then((u) => {
							resolve(u);
						});
					} else {
						await dispatch("storeAndLoadData", user.restoid).then((u) => {
							resolve(u);
						});
					}
				})
				// cookie connection to mongodb didn't exist
				.catch((err) => {
					console.error(err);
					reject(new Error("Connection faild go to login"));
				});
		});
	},
	async storeAndLoadData({ state, getters, rootState, commit, dispatch }, uid) {
		return new Promise(async (resolve, reject) => {
			let userDatas = getters["getUser"];
			await fetchGetHelper(
				ERequestType.USERS.GET,
				`restoid=${uid}`,
				userDatas.token,
			)
				.then((res) => {
					let u = res.data;
					// check user version — logout if password was changed elsewhere
					if (userDatas.user?.role === "User" && u.version !== userDatas.user.version) {
						dispatch("logout");
					} else {
						commit("setUserDatas", u);
						commit("setUidPublic", uid);
						dispatch("loadPublicStoreModules", null, { root: true });
						// loading stores
						dispatch("loadStoreModules", null, { root: true });
						resolve(u);
					}
				})
				.catch((err) => {
					console.error(err);
					dispatch("logout");
					reject(err);
				});
		});
	},
	async checkUserStillValid({ state, getters, rootState, commit, dispatch }) {
		return new Promise(async (resolve, reject) => {
			let userDatas = getters["getUser"];
			if (userDatas?.user?.role === "User") {
				try {
					await fetchGetHelper(
						ERequestType.USERS.GET,
						`restoid=${userDatas.user.restoid}`,
						userDatas.token,
					).then((res) => {
						let u = res.data;
						// check user version
						if (u.version !== userDatas.user.version) {
							dispatch("logout");
						} else {
							resolve();
						}
					});
				} catch (err) {
					console.error(err);
					dispatch("logout");
				}
			} else {
				resolve();
			}
		});
	},
	async loadAUsers({ state, rootState, commit, dispatch, getters }) {
		let users = [];
		try {
			let userDatas = getters["getUser"];
			await fetchGetHelper(
				ERequestType.USERS.GETALL,
				null,
				userDatas.token,
			).then(async (res) => {
				for (let i = 0; i < res.data.length; i++) {
					let user = res.data[i];
					await fetchGetHelper(
						ERequestType.INFOS.GET,
						`restoid=${user.restoid}`,
					).then((resInfos) => {
						users.push({
							id: user.restoid,
							name: resInfos.data.restoName,
							data: user,
							infos: resInfos.data,
						});
					});
				}
			});
			commit("setAUser", users);
			return users;
		} catch (err) {
			console.error("loadAUsers - Error get document", err);
		}
	},
	findRealUserRole: function ({ state, rootState, commit, dispatch }) {
		return new Promise((resolve, reject) => {
			resolve(state.currentUser.user.role);
		});
	},
	resetPass: function ({ state, rootState, commit }, mail) {
		alert(
			"Bonjour, veuillez contacter l'équipe resa.ninja pour réaliser cette modification",
		);
	},
	checkPassword: function ({ state, getters, rootState, commit }, payload) {
		return new Promise((resolve, reject) => {
			let userDatas = getters["getUser"];
			let logObject = {
				email: userDatas.user.email,
				password: payload,
			};
			fetchPostHelper(ERequestType.USERS.CHECK_PWD, logObject).then((res) => {
				if (res.data) {
					resolve();
				} else {
					let message = "Le mot de passe renseigné n'est pas correct";
					alert(`Erreur : ${message}`);
					reject(res.data);
				}
			});
		});
	},
};

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
